import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// context
import { MenuContext } from 'context/menuContext';
// redux
import { useSelector } from 'react-redux';
import { companySelector } from 'slices/company';
// api
import { getPosts } from 'api/blog';
// components
import Head from 'components/metatags_helmet/metatags';
import CardBlog from 'components/blog/cardBlog';
import BlogCategories from 'components/blog/BlogCategories';
import NoResults from 'components/userzone/NoResults';
import NoResultIcon from 'assets/img/no_item_found.jpg'
import Pagination from 'components/userzone/Pagination';

const DatePublishPost = ({ post }) => {
  const date = new Date(post.publish_date);
  return (
    <Row key={'info-' + post.id}>
      <span>{`Publicado el ${date.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })} a las ${post.publish_time} por ${post.author}`}</span>
    </Row>
  );
};

const PostList = () => {
  const { t } = useTranslation(['blog']);
  const title = t('libelistworld');
  const { descripcion_pub } = useSelector(companySelector);
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { blogCategories } = useContext(MenuContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const getPostList = async (query) => {
    const rs = await getPosts(query);
    if (rs.status === 200) {
      setPosts(rs.data.results);
      setCurrentPage(query.page || 1);
      setTotalPages(Math.ceil(rs.data.count / 10));
      setLoaded(true);
    }
  };

  useEffect(() => {
    getPostList({ page: currentPage });
  }, [currentPage]);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  };
  goUp();

  if (loaded) {
    return (
      <div className="content mainDiv">
        <div className="container-fluid blog">
          <Head description={descripcion_pub} title={title} noIndex={true} />
          <Row>
            <Col md={12}>
              <h1 className="page-title static-title">{title}</h1>
            </Col>
          </Row>
          <div className="container-fluid p-rel p-0">
            <div className="blogContainer">
              <Col md={12} lg={8} xl={9}>
                {posts.length > 0 ? <div className="containerPostList">
                  <Row className='pe-lg-3 pe-0'>
                    {posts.map((post, i) => (
                      <Col key={i} xs={12} md={i === 0 ? 12 : 4} className="mb-5">
                        <CardBlog event={post} isContainer={true} index={i} isFirstPost={i === 0} />
                      </Col>
                    ))}
                  </Row>
                  <Row className="mb-4">
                    <Col md={12} className="d-flex justify-content-center align-items-center">
                      <Pagination changePage={changePage} page={currentPage} totalPages={totalPages} />
                    </Col>
                  </Row>
                </div> :
                  <NoResults text={t('noarticles')} icon={NoResultIcon} />}
              </Col>
              <Col md={12} lg={4} xl={3} className="blog-aside">
                {blogCategories.length > 0 && <BlogCategories blogCategories={blogCategories} />}
                {posts.length > 0 && <div className="blog-aside-mostvisited">
                  <h2 className="section-col mt-3">{t('mostvisited')}</h2>
                  <Row className='m-0'>
                    {posts.slice(0, 3).map((post, i) => (
                      <Col key={i} xs={12} md={12} className="mb-4">
                        <CardBlog event={post} isColumn={true} />
                      </Col>
                    ))}
                  </Row>
                </div>}
              </Col>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <Container className="container-spinner">
        <Spinner animation={'grow'} className="spinner-blog" />
      </Container>
    );
  }
};

export { DatePublishPost, PostList };